'use strict';

export function initSmoothSticky(selector, top = 0) {
  const stickyEl = document.querySelector(selector);
  if (!stickyEl) return;

  const parent = stickyEl.parentElement;
  if (!parent) return;

  // obliczamy padding-top rodzica
  const parentStyle = getComputedStyle(parent);
  const parentPaddingTop = parseFloat(parentStyle.paddingTop) || 0;
  const parentPaddingBottom = parseFloat(parentStyle.paddingBottom) || 0;

  const elHeight = stickyEl.offsetHeight;
  const parentHeight = parent.offsetHeight;

  const updatePosition = scrollY => {
    const parentRect = parent.getBoundingClientRect();
    const parentTop = parentRect.top + scrollY + parentPaddingTop;
    const parentBottom = parentTop + parentHeight - parentPaddingBottom;

    // górna granica sticky
    const stickyStart = parentTop - top;

    // dolna granica sticky
    const stickyEnd = parentBottom - elHeight - top;

    // przeliczanie pozycji
    let y = scrollY;

    if (scrollY < stickyStart) {
      // element jeszcze normalnie przewija się
      y = 0;
    } else if (scrollY > stickyEnd) {
      // element osiągnął dół rodzica
      y = stickyEnd - parentTop;
    } else {
      // element przyklejony
      y = scrollY - parentTop + top;
    }

    stickyEl.style.transform = `translateY(${y}px)`;
  };

  if (
    window.smoothScroll &&
    typeof window.smoothScroll.addListener === 'function'
  ) {
    window.smoothScroll.addListener(({ offset }) => {
      updatePosition(offset.y);
    });
  } else {
    window.addEventListener('scroll', () => {
      const scroll = window.scrollY || document.documentElement.scrollTop;
      updatePosition(scroll);
    });
  }
}
